<template>
  <div
    class="personCard"
    @click="clickCard(content.id)"
    :class="content.isExpired == '1' ? 'yuqi' : ''"
  >
    <!-- <img
      src="../common/images/progress/yuqi.png"
      class="yuqi_bg"
      v-if="content.isExpired == '1'"
    /> -->
    <div class="xuhao">{{ index }}</div>
    <div class="name">{{ content.presentee }}</div>
    <div class="gender">
      <img :src="content.gender == 0 ? nan_select_icon : nv_select_icon" alt />
    </div>
    <div class="tel">{{ content.contactNumber }}</div>
    <div class="time" v-if="type == '0'">
      <div class="times">
        <div class="hour">
          {{ timeResult[0] }}
        </div>
        <div class="hour">
          {{ timeResult[1] }}
        </div>
      </div>
      <span>:</span>
      <div class="times">
        <div class="hour">
          {{ timeResult[2] }}
        </div>
        <div class="hour">
          {{ timeResult[3] }}
        </div>
      </div>
    </div>
    <div class="time" v-else>{{ forMatterTimes(content.updateDate) }}</div>
    <img
      src="../common/images/progress/okrengou.png"
      class="okrengou"
      v-if="type == '1' && content.status == 5"
    />
  </div>
</template>

<script>
export default {
  props: {
    // 已跟进 /待跟进
    type: {
      type: [String, Number],
      default: "0",
    },
    // 内容
    content: {
      type: Object,
      default: () => {},
    },
    noDisposeTime: Number,
    // 序号
    index: {
      type: Number,
    },
  },
  watch: {
    content(res) {
      // if (res.countdown) {
      //   this.timer = setInterval(() => {
      //     this.computeDate();
      //   }, 1000);
      // }
      // console.log("变化了");
    },
  },
  created() {
    if (this.noDisposeTime) {
      this.timer = setInterval(() => {
        this.computeDate();
      }, 1000);
    }
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  data() {
    return {
      nan_select_icon: require("../common/images/recommend/sex_nan_select.png"),
      nv_select_icon: require("../common/images/recommend/sex_nv_select.png"),
      time_bg: require("../common/images/progress/time_bg.png"),
      timeResult: [],
      timer: "",
      noDispose_Time: this.noDisposeTime,
    };
  },
  methods: {
    forMatterTimes(data) {
      return data && data.split(" ")[0].replace(/[-]/g, "/");
    },
    clickCard(e) {
      this.$emit("onClick", { id: e, type: this.type });
    },
    computeDate() {
      let data = [];

      this.noDispose_Time = Number(this.noDispose_Time) - 1000;
      if (this.noDispose_Time <= 0) {
        this.noDispose_Time = 0;
        clearInterval(this.timer);
      }
      let result = parseInt(this.noDispose_Time / 1000);
      let h =
        (Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600)) + "";
      let m =
        (Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60)) + "";
      data[0] = h.substr(0, 1);
      data[1] = h.substr(1, 1);
      data[2] = m.substr(0, 1);
      data[3] = m.substr(1, 1);

      this.timeResult = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.yuqi {
  background: #f7f7f7;
  .yuqi_bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 90px;
    height: 70px;
  }
}
.okrengou {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 96px;
  height: 60px;
}
.personCard {
  width: 100%;
  height: 120px;
  display: flex;
  color: #333333;
  position: relative;
  font-size: 28px;
  align-items: center;
  padding-left: 30px;
  padding-right: 38px;
  margin-bottom: 30px;
  box-sizing: border-box;
  border-radius: 16px;
  box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
  div {
    text-align: center;
  }
  .xuhao {
    width: 20px;
  }
  .name {
    flex: 1;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
  }
  .gender {
    width: 70px;
    text-align: left;
    img {
      width: 36px;
      height: 42px;
    }
  }
  .tel {
    width: 220px;
    text-align: left;
  }
  .time {
    width: 150px;
    height: 42px;
    font-family: PingFangSC-Medium, PingFang SC;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    span {
      flex: 1;
    }
    .times {
      width: 62px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .hour {
        width: 30px;
        height: 100%;
        background-image: url("../common/images/progress/time_bg.png");
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
